import { create } from 'zustand';

import { TrapTableType } from 'components/TrapsTables/trapTables';

interface EditTrapModalState {
  slug: string;
  isOpen: boolean;
  trap?: { serialNumber: string; pk: number };
  trapType?: TrapTableType;
  onEditTrapModalClose: () => void;
  onEditTrapModalOpen: (slug: string, trapId?: { serialNumber: string; pk: number }, trapType?: TrapTableType) => void;
}

export const useEditTrapModalStore = create<EditTrapModalState>(set => ({
  isOpen: false,
  slug: '',
  trapId: undefined,
  trapType: undefined,
  onEditTrapModalClose: () => set({ isOpen: false, slug: '', trap: undefined, trapType: undefined }),
  onEditTrapModalOpen: (slug: string, trap?: { serialNumber: string; pk: number }, trapType?: TrapTableType) =>
    set({ isOpen: true, slug, trap, trapType }),
}));
